<template>
  <div class="page">
    <div class="bj-search-section">
      <div class="bj-search-row">
        <div class="item">
          <div class="name" style="margin-right: 10px">选择默认模板：</div>
          <div
            v-if="templateId"
            @click="showCheckedTemplate"
            style="color: #fff; cursor: pointer"
          >
            {{ templateName }}
          </div>
          <Button
            v-else
            type="primary"
            class="bj-search-btn-F85A36"
            @click="showCheckedTemplate"
            >选择模板</Button
          >
        </div>
      </div>
    </div>
    <Button
      class="bj-w120 bj-h45 bj-confirm-btn"
      style="margin-top: 20px"
      :loading="loading"
      type="primary"
      @click="onConfirm"
      >确认提交</Button
    >
    <templateListModal
      :show.sync="templateListModalVisibility"
      :id="templateId"
      @onChecked="checkedTemplate"
    ></templateListModal>
  </div>
</template>

<script>
import { getTemplatesDefault, templatesDefaultSave } from "api/domain.js";
import templateListModal from "components/template/templateListModal.vue";
export default {
  name: "templateDefault",
  components: {
    templateListModal,
  },
  data() {
    return {
      templateId: "",
      templateName: "",
      loading: false,
      templateListModalVisibility: false,
    };
  },
  created() {
    this.req_getTemplatesDefault();
  },
  methods: {
    async req_getTemplatesDefault() {
      try {
        const { code, data } = await getTemplatesDefault();
        if (code === 200) {
          this.templateId = data.id;
          this.templateName = data.name;
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 打开选择模板
    showCheckedTemplate() {
      this.templateListModalVisibility = true;
    },
    // 选中模板回调
    checkedTemplate(val) {
      this.templateId = val.id;
      this.templateName = val.name;
      this.templateListModalVisibility = false;
    },
    async onConfirm() {
      this.loading = true;
      try {
        const { code } = await templatesDefaultSave({
          domainTemplateId: this.templateId,
        });
        this.loading = false;
        if (code === 200) {
          this.$Message.success("操作成功！");
        }
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style lang="less" scoped>
.bj-search-section {
  background-color: #28292c;
  padding: 14px 28px;
  border-radius: 6px;
  margin-top: 30px;
  .bj-search-row {
    display: flex;
    .item {
      display: flex;
      align-items: center;
      .name {
        color: #fff;
      }
    }
  }
}
</style>
